// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleParagraph_root__wy3UI","dropcap":"ArticleParagraph_dropcap__Xra23"};